const removeFieldValidation = (field) => ({
    validatedField: {
        id: field.id,
    },
});

export {
    removeFieldValidation,
};
